import { render, staticRenderFns } from "./Reassurance.vue?vue&type=template&id=28050c76&"
import script from "./Reassurance.vue?vue&type=script&lang=js&"
export * from "./Reassurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports